module.exports = __webpack_public_path__ + "static/media/jack-o-lantern.c5266418.svg";